import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UserLogged } from '../dto/user/userLogged';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { DataService } from './data.service';
import Swal from 'sweetalert2';
import { SpinnerService } from './spinner.service';
import { Role } from '@/enum/role';
import jwtDecode from 'jwt-decode';
import { SignInService } from './signin.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService implements OnDestroy {
  private currentUserSubject: BehaviorSubject<UserLogged>;
  public currentUser: Observable<UserLogged>;
  public id: string;
  private unsubscribe: Subscription[] = [];
  constructor(private router: Router, private dataService: DataService, private idle: Idle, private spinnerService: SpinnerService,
    private signInService: SignInService) {
    this.currentUserSubject = new BehaviorSubject<UserLogged>(JSON.parse(localStorage.getItem("")));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): UserLogged {
    return this.currentUserSubject.value;
  }

  login(jwt: string) {
    let userlog = new UserLogged();
    const decode = jwtDecode(jwt);
    if (decode["is_superuser"])
      userlog.role = Role.Admin
    userlog.id = decode["user_id"];
    userlog.token = jwt;
    userlog.role = decode["role"]
    this.currentUserSubject.next(userlog);
    localStorage.setItem("jwt", userlog.token);
  }

  logout() {
    const getJwt = localStorage.getItem("jwt");
    if( !getJwt || getJwt == '' ) return this.router.navigate(['/']);

    this.currentUserSubject.next(null);
    this.idle.stop();
    this.unsubscribe.forEach(s => s.unsubscribe());
    //this.signInService.SignOutApp().subscribe();
    localStorage.setItem("jwt", '');
    this.router.navigate(['/']);

  }

  inactivity() {
    // this.idle.setIdle(5);
    // this.idle.setTimeout(300);
    // this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    // this.unsubscribe.push(this.idle.onTimeout.subscribe(() => {
    //   this.dataService.GetDialogRefValue()?.close();
    //   Swal.close(null);
    //   this.spinnerService.hide();
    //   this.logout();
    // }));
    // this.idle.watch();
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }
}
